<ng-container>
  <div class="ppt-body-content">
    <div class="record-address-section">
      <rep-presentation-dynamic-view-header
        [reportData]="recordData"
        [reportRecordData]="recordData"
        [currentView]="currentView()"
        [headerGroups]="headerGroups()"
        [templateProjectionMap]="templateProjectionMap()"
      ></rep-presentation-dynamic-view-header>
    </div>
    <div class="record-img-attribute-section">
      <div class="record-img-content">
        <rep-presentation-dynamic-view-image
          [reportId]="reportData()?.reportId"
          [reportRecordData]="recordData"
          [imageGroups]="imageGroups()"
          [currentView]="currentView()"
        ></rep-presentation-dynamic-view-image>
      </div>
      <div class="record-attribute-content">
        @if (bodyAttributes) {
          <div class="property-info-section">
            <!-- Entity attributes and values -->
            <ul>
              @for (field of bodyAttributes.fields; track field) {
                <li [class]="field.class ? field.class : ''">
                  <label>{{
                    recordData
                    | reportLabelFormatter
                    : {
                    templateId: currentView().templateId,
                    field: field,
                  }
                }}</label>
                <span>{{
                  recordData
                  | reportFieldFormatter
                  : {
                  templateId: currentView().templateId,
                  field: field,
                  joinString: true,
                  onlyUrl: false,
                }
                | async
              }}</span>
            </li>
          }
        </ul>
      </div>
    }
    <ng-container>
      <div
        class="bottom-section"
        [ngClass]="tableFields?.fields?.length && footerAttributes?.length ? 'inline-bottom-section' : ''"
        >
        @if (tableFields) {
          <div class="table-section">
            @if (tableFields.tableConfigs?.tableTitle) {
              <h3 class="table-title">
                {{ recordData?.data.length }}
                {{ (recordData?.data.length > 0 ? 'template.availabilities' : 'template.availability') | translate }}
              </h3>
            }
            <table class="template-table">
              <thead>
                <tr>
                  @if (tableFields.tableConfigs?.actionCol) {
                    <th></th>
                  }
                  @for (col of tableFields.fields; track col) {
                    @if (recordData | isFieldVisible: { templateId: currentView().templateId, field: col }) {
                      <th
                        [ngClass]="col.class"
                        >
                        <span>{{ col.label }}</span>
                      </th>
                    }
                  }
                  @if (
                    !footerAttributes?.length &&
                    templateProjectionMap() &&
                    (templateProjectionMap() | selectTemplateOutlet: 'miq-confidentiality-control-tmpl')
                    ) {
                    <th
                      >
                      {{ 'template.reportConfidentiality' | translate }}
                    </th>
                  }
                </tr>
              </thead>
              <tbody cdkDropList (cdkDropListDropped)="onReorder($event, recordData)">
                @if (tableData?.length > 0) {
                  @for (data of tableData; track data; let i = $index) {
                    <tr cdkDrag cdkDragLockAxis="y">
                      <!-- Action buttons -->
                      @if (tableFields.tableConfigs?.actionCol) {
                        <td class="actions">
                          <a class="action-element"
                            ><mat-icon
                            class="handle print-hidden"
                            svgIcon="alt-handle-icon"
                            color="y-icon"
                            cdkDragHandle
                            ></mat-icon
                          ></a>
                          <a class="action-element" (click)="removeRecord.emit(data)"
                            ><mat-icon class="green-close" color="y-icon" svgIcon="close-icon-grey"></mat-icon
                          ></a>
                          <!-- TODO: instead of goToRecordDetails() method need to use miq-goes-to-record once feild from BE is available -->
                          <a (click)="goToRecordDetails(data)" class="action-element">
                            <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"> </mat-icon>
                          </a>
                          <b>{{ i + 1 }}.</b>
                        </td>
                      }
                      <!-- Columns -->
                      @for (col of tableFields.fields; track col; let i = $index) {
                        @if (recordData | isFieldVisible: { templateId: currentView().templateId, field: col }) {
                          <td>
                            <span>{{
                              { recordId: null, position: null, edpRecordId: null, confidentiality: null, data: [data] }
                              | reportFieldFormatter
                              : {
                              templateId: currentView().templateId,
                              field: col,
                              joinString: true,
                              onlyUrl: false,
                            }
                            | async
                          }}</span>
                        </td>
                      }
                    }
                    <!-- Confidentiality selector -->
                    @if (
                      !footerAttributes?.length &&
                      templateProjectionMap() &&
                      (templateProjectionMap() | selectTemplateOutlet: 'miq-confidentiality-control-tmpl')
                      ) {
                      <td
                        >
                        <div class="confidentiality-container">
                          <ng-container
                            [ngTemplateOutlet]="
                              templateProjectionMap() | selectTemplateOutlet: 'miq-confidentiality-control-tmpl'
                            "
                            [ngTemplateOutletContext]="{
                              record: data,
                              reportItem: recordData,
                              displayLabel: true,
                              isDataOnly: true,
                            }"
                          ></ng-container>
                        </div>
                      </td>
                    }
                  </tr>
                }
                @if (tableData?.length === 0) {
                  <tr>
                    <td [attr.colspan]="tableFields.tableConfigs.colspan">{{ 'template.noData' | translate }}</td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      }
      @if (footerAttributes?.length) {
        <div class="property-info-section">
          <!-- Confidentiality selector -->
          @if (
            templateProjectionMap() &&
            (templateProjectionMap() | selectTemplateOutlet: 'miq-confidentiality-control-tmpl')
            ) {
            <div
              class="confidentiality-container"
              >
              <ng-container
                [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet: 'miq-confidentiality-control-tmpl'"
                [ngTemplateOutletContext]="{ reportItem: recordData, displayLabel: true }"
              ></ng-container>
            </div>
          }
          <ul>
            @for (field of footerAttributes; track field) {
              @if (recordData | isFieldVisible: { templateId: currentView().templateId, field: field }) {
                <li
                  [class]="field.class ? field.class : ''"
                  >
                  <label>{{ field.label }}</label>
                  <span class="field-value">{{
                    recordData
                    | reportFieldFormatter
                    : {
                    templateId: currentView().templateId,
                    field: field,
                    joinString: true,
                    onlyUrl: false,
                  }
                  | async
                }}</span>
              </li>
            }
          }
        </ul>
      </div>
    }
  </div>
  <floor-plan
    [reportId]="reportData()?.reportId"
    [reportRecordData]="recordData"
    [templateId]="currentView().templateId"
  ></floor-plan>
</ng-container>
</div>
</div>
<div class="div-disclaimer">
  <span>{{ 'recordPPT.primaryImageDisclaimer' | translate }}</span>
</div>
</div>
</ng-container>
